<template>
  <div class="smb-sales_container">
    <div class="smb-sales_container_title">
      <div class="smb-sales_container_title__left">
        Members {{ partnerType }}
      </div>
    </div>
    <div class="smb-sales_container_table">
      <el-table :data="tableList" border max-height="450">
        <el-table-column
          label="Name"
          show-overflow-tooltip
          prop="subAccountName"
        />
        <el-table-column
          label="Job Title"
          prop="workPost"
          show-overflow-tooltip
        />
        <el-table-column
          label="Work Email"
          prop="subAccountMail"
          show-overflow-tooltip
        />
        <el-table-column
          label="Permissions"
          prop="permissions"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <template v-if="row.permissions">
              <template v-for="permission in row.permissions">
                <span>{{ permission }}</span
                ><br />
              </template>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="smb-sales_tips">
        <img
          src="@/assets/tool-tip_icon.svg"
          width="18px"
          height="18px"
          alt=""
        />
        <div class="smb-sales_desc" style="color: #e60039;">
          Partner Member List displays all linked sub-accounts. If you want to
          add or modify them.<span
            class="click-span"
            @click="handleToMemberAccessManagement"
            >please go to Member Access Managerment in the Partner Center.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAccountByMasterNotReject,
  getWordTranslationList,
  getAccountByMasterNotRejectCurrency,
} from "../../../../../api/international";

export default {
  name: "otherContacts",
  props: {
    // 编辑类型 基础 base或者高级senior 默认基础
    masterAccount: {
      type: String,
      default: ""
    },
    partnerType: {
      type: String,
      default: ""
    },
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableList: []
    };
  },
  watch: {
    masterAccount() {
      this.fetchSubAccount();
    }
  },
  mounted() {
    if (this.masterAccount && this.partnerType) {
      this.fetchSubAccount();
    }
  },
  methods: {
    fetchSubAccount() {
      if (!this.masterAccount) return;
      if(this.isDetail) {
        getAccountByMasterNotRejectCurrency(this.masterAccount, this.partnerType).then(
        res => {
          if (Number(res.status) === 200) {
            this.tableList = res.data.list;
            const wordList = Array.from(
              new Set(
                res.data.list.reduce((prev, current) => {
                  const ownedPermissionStrList =
                    current["ownedPermissionStrList"];
                  if (!ownedPermissionStrList) {
                    return prev;
                  } else {
                    const wordKeyList = [];
                    Object.entries(ownedPermissionStrList).forEach(
                      ([key, value]) => {
                        wordKeyList.push(key);
                        if (Array.isArray(value)) {
                          wordKeyList.push(...value);
                        }
                      }
                    );
                    return [...prev, ...wordKeyList];
                  }
                }, [])
              )
            );
            getWordTranslationList({
              wordCodeList: wordList,
              languageCode: "en-US"
            }).then(res => {
              const { status, data } = res;
              if (Number(status) === 200) {
                this.tableList.forEach(item => {
                  const ownedPermissionStrList = item["ownedPermissionStrList"];
                  this.$set(item, "permissions", []);
                  Object.entries(ownedPermissionStrList).forEach(
                    ([key, value]) => {
                      item.permissions.push(
                        `[${data[key]}]: ` + Array.isArray(value)
                          ? value.map(code => data[code]).join(" ")
                          : ""
                      );
                    }
                  );
                });
              }
            });
          }
        }
      );
      } else {
      getAccountByMasterNotReject(this.masterAccount, this.partnerType).then(
        res => {
          if (Number(res.status) === 200) {
            this.tableList = res.data.list;
            const wordList = Array.from(
              new Set(
                res.data.list.reduce((prev, current) => {
                  const ownedPermissionStrList =
                    current["ownedPermissionStrList"];
                  if (!ownedPermissionStrList) {
                    return prev;
                  } else {
                    const wordKeyList = [];
                    Object.entries(ownedPermissionStrList).forEach(
                      ([key, value]) => {
                        wordKeyList.push(key);
                        if (Array.isArray(value)) {
                          wordKeyList.push(...value);
                        }
                      }
                    );
                    return [...prev, ...wordKeyList];
                  }
                }, [])
              )
            );
            getWordTranslationList({
              wordCodeList: wordList,
              languageCode: "en-US"
            }).then(res => {
              const { status, data } = res;
              if (Number(status) === 200) {
                this.tableList.forEach(item => {
                  const ownedPermissionStrList = item["ownedPermissionStrList"];
                  this.$set(item, "permissions", []);
                  Object.entries(ownedPermissionStrList).forEach(
                    ([key, value]) => {
                      item.permissions.push(
                        `[${data[key]}]: ` + Array.isArray(value)
                          ? value.map(code => data[code]).join(" ")
                          : ""
                      );
                    }
                  );
                });
              }
            });
          }
        }
      );
    }
    },
    handleToMemberAccessManagement() {
      window.open(
        window._env_.BASE_Partner +
          "myRuiJie/AccessManagement/MenberAccessManagen?params=85"
      );
    }
  }
};
</script>

<style scoped>
.smb-sales_tips {
  margin-top: 10px;
}
.click-span {
  color: #007aff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/SBG/components/members.vue